import React, { useState } from "react";
import {Col, Container, Row,Table } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import Navbar from "../../../Components/Navbar/Navbar";
import {
    numberFormat,
    toastStyle,
    refreshPage,
    getTodayDateISO,
    dateFormat,
    getType,
} from "../../../Helpers/Utils/Common";
import toast from "react-hot-toast";
import Moment from "moment";
import cleanLogo from "../../../Assets/Images/Login/transparent_bg.png";
import { 
    getRequest, 
    changeRequestStatus,
} from "../../../Helpers/apiCalls/Inventory/RequestsApi";
import RequestModal from "./RequestModal";
import ApproveRequestModal from "./ApproveRequestModal";
import ReactLoading from "react-loading";
import Footer from "../../../Components/Footer/Footer";


export default function ViewRequest() {
    const { id, type } = useParams();
    let navigate = useNavigate();

    const [inactive, setInactive] = useState(true);
    const [isSet, setIsSet] = useState(false);
    const [items, setItems] = useState([]);
    const accountType = getType()

    const [request, setRequest] = useState([]);
    const [isClicked, setIsClicked] = useState(false);


    /* print modal handler */
    const [showPrintModal, setShowPrintModal] = useState(false);
    const handleShowPrintModal = () => setShowPrintModal(true);
    const handleClosePrintModal = () => setShowPrintModal(false);

     /* Approve Modal */
     const [showApproveModal, setShowApproveModal] = useState(false);
     const handleShowApproveModal = () => setShowApproveModal(true);
     const handleCloseApproveModal = () => setShowApproveModal(false);

     /* Approve Modal */
     const [showForApprovalModal, setShowForApprovalModal] = useState(false);
     const handleShowForApprovalModal = () => setShowForApprovalModal(true);
     const handleCloseForApprovalModal = () => setShowForApprovalModal(false);

     /* Disapprove Modal */
     const [showDisapproveModal, setShowDisapproveModal] = useState(false);
     const handleShowDisapproveModal = () => setShowDisapproveModal(true);
     const handleCloseDisapproveModal = () => setShowDisapproveModal(false);

    async function handlePrintPI() {
        toast.loading("Printing Transfer Details", { style: toastStyle() });
        handleClosePrintModal();
        setTimeout(() => {
            toast.dismiss();
            Print();
        }, 1000);
    }

    function Print() {
        let printContents = document.getElementById("printablediv").innerHTML;
        let originalContents = document.body.innerHTML;
        document.body.innerHTML = printContents;
        window.print(printContents);
        document.body.innerHTML = originalContents;
        refreshPage();
    }

    async function fetchRequest() {
            const response = await getRequest(id);
            
            if (response.data) {
                var data = response.data.data[0];
                data.shopType = "";
                setRequest(data)
                setItems(data.request_items)
                setIsSet(true);
            }
    }

    function redirectToTransfer() {
        navigate("/transfers/add/" + id)
    } 

    async function approveRequest() {
        if (isClicked) {
            return;
        }
            setIsClicked(true);
            const response = await changeRequestStatus(id, "pending");
            
            if (response.data) {
                toast.success("Successfully approved request!", {
                    style: toastStyle(),
                });
                setTimeout(() => {
                    navigate("/requests");
                }, 1000);
            } else if (response.error) {
                toast.error(
                    "Something went wrong",
                    { style: toastStyle() }
                );
            }
            setIsClicked(false);

    }

    function renderTable() {
        return (
            <Table className="">
                <thead>
                    <tr>
                        <th className="text-end">Request Qty</th>
                        <th>Unit</th>
                        <th>Item</th>
                        <th className="text-end">Remaining Bal</th>
                    </tr>
                </thead>
                <tbody>
                    {isSet
                        ? items.map((item, index) => {
                              return (
                                  <tr key={item.id} className="req-table-w-border-bottom">
                                      <td className="franchise-td-gray text-end">{item.qty ? numberFormat(item.qty) : 0}</td>
                                      <td className="franchise-td-gray">{item.unit}</td>
                                      <td className="franchise-td-gray">{item.item_name}</td>
                                      <td className="franchise-td-gray text-end">{item.current_qty ? numberFormat(item.current_qty) : 0}</td>
                                  </tr>
                              );
                          })
                        : ""}
                </tbody>
            </Table>
        );
    }

    function renderTablePrint() {
        return (
            <Table className="">
                <thead>
                    <tr>
                        <th className="text-end">Transfer Qty</th>
                        <th>Unit</th>
                        <th>Item</th>
                        <th className="text-end">Request Qty</th>
                    </tr>
                </thead>
                <tbody>
                    {isSet
                        ? items.map((item, index) => {
                              return (
                                  <tr key={item.id} className="req-table-w-border-bottom">
                                      <td className="franchise-td-gray"></td>
                                      <td className="franchise-td-gray">{item.unit}</td>
                                      <td className="franchise-td-gray">{item.item_name}</td>
                                      <td className="franchise-td-gray text-end">{item.qty ? numberFormat(item.qty) : 0}</td>
                                  </tr>
                              );
                          })
                        : ""}
                </tbody>
            </Table>
        );
    }

    React.useEffect(() => {
        fetchRequest();
    }, []);

    return (
        <div>
            <div className="page">
                <Navbar
                    onCollapse={(inactive) => {
                        setInactive(inactive);
                    }}
                    active={"TRANSFERS"}
                />
            </div>
            <div className={`manager-container ${inactive ? "inactive" : "active"} review-container-main`}>
                <div className="d-flex justify-content-between d-flex-responsive">
                    <h1 className="page-title mb-4">REQUEST DETAILS </h1>
                    <div className="review-po">
                        <span className="pe-5">REQUEST NO.</span>
                        <span>{request.id}</span>
                    </div>
                </div>

                {/* content */}
                <div className="review-form mb-3">
                    {/* TRANSACTION/PAYMENT DETAILS */}
                
                    <Container fluid>
                        <Row className="review-container py-3">
                            <Row>
                                <Col>
                                    <span className="review-label nc-modal-custom-row">
                                        Doc No.
                                    </span>
                                </Col>
                                <Col>
                                    <span className="review-label nc-modal-custom-row">
                                        Request Date
                                    </span>
                                </Col>
                                <Col>
                                    <span className="review-label nc-modal-custom-row">
                                        Delivery Date
                                    </span>
                                </Col>
                                <Col>
                                    <span className="review-label nc-modal-custom-row">
                                        Encoded By
                                    </span>
                                </Col>
                                <Col>
                                    <span className="review-label nc-modal-custom-row">
                                        Approved By
                                    </span>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <span className="review-data">
                                        {request.id}
                                    </span>
                                </Col>
                                <Col>
                                    <span className="review-data">
                                        {dateFormat(request.request_date)}
                                    </span>
                                </Col>
                                <Col>
                                    <span className="review-data">
                                        {dateFormat(request.delivery_date)}
                                    </span>
                                </Col>
                                <Col>
                                    <span className="review-data">
                                        {request.encoded_by_name}
                                    </span>
                                </Col>
                                <Col>
                                    <span className="review-data">
                                        {request.approved_by_name}
                                    </span>
                                </Col>
                            </Row>
                        </Row>
                        <Row className="review-container py-3">
                            <Row>
                                <Col>
                                    <span className="review-label nc-modal-custom-row">
                                        Request from
                                    </span>
                                </Col>
                                <Col>
                                    <span className="review-label nc-modal-custom-row">
                                        Request To
                                    </span>
                                </Col>
                                <Col>
                                    <span className="review-label nc-modal-custom-row">
                                        Remarks
                                    </span>
                                </Col>
                                <Col>
                                    <span className="review-label nc-modal-custom-row">
                                        Approval Remarks
                                    </span>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <span className="review-data">
                                        {request.branch_from_name}
                                    </span>
                                </Col>
                                <Col>
                                    <span className="review-data">
                                        {request.branch_to_name}
                                    </span>
                                </Col>
                                <Col>
                                    <span className="review-data">
                                        {request.remarks}
                                    </span>
                                </Col>
                                <Col>
                                    <span className="review-data">
                                        {request.approval_remarks}
                                    </span>
                                </Col>
                            </Row>
                        </Row>
                    </Container>

                    <div className="mt-4 d-flex flex-column">
                        <span className="review-data mb-2 nc-modal-custom-row">
                            LIST OF ITEMS REQUESTED
                        </span>
                        <div className="d-flex mt-2 justify-content-evenly">
                            <div className="print-table mt-3 mx-2">
                                {renderTable()}
                            </div>
                        </div>
                    </div>

                    {(type !== "pending" && type !== "completed" && type !== "on hold" && type !== "processing") && (
                        <div className="d-flex justify-content-end pt-5">
                            <button
                                type="button"
                                className="button-secondary me-3"
                                onClick={handleShowPrintModal}
                            >
                                Print
                            </button>
                            <button
                                type="button"
                                className="button-secondary me-3"
                                onClick={() => navigate("/requests")}
                            >
                                Close
                            </button>
                            {
                                (accountType === "admin" || accountType === "warehouse_manager" || accountType === "branch_oic") && (
                                    <>
                                    <button
                                        type="button"
                                        className="button-warning me-3"
                                        onClick={handleShowDisapproveModal}
                                    >
                                        Reject
                                    </button>
                                    <button
                                        type="button"
                                        className="button-primary me-3"
                                        onClick={handleShowForApprovalModal}
                                    >
                                        Approve
                                    </button>
                                    </>
                                )
                            }
                        </div>
                    )}
                    {(type === "completed" || type === "on hold" || type === "processing") && (
                        <div className="d-flex justify-content-end pt-5">
                            <button
                                type="button"
                                className="button-secondary me-3"
                                onClick={() => navigate("/requests")}
                            >
                                Close
                            </button>
                            <button
                                type="button"
                                className="button-primary me-3"
                                onClick={handleShowPrintModal}
                            >
                                Print
                            </button>
                        </div>
                    )}
                    {type === "pending" && (
                        <div className="d-flex justify-content-end pt-5">
                            <button
                                type="button"
                                className="button-secondary me-3"
                                onClick={handleShowPrintModal}
                            >
                                Print
                            </button>
                            {isClicked ? (
                                <div className="button-warning me-3 d-flex justify-content-center">
                                    <ReactLoading
                                        type="bubbles"
                                        color="#FFFFFF"
                                        height={50}
                                        width={50}
                                    />
                                </div>
                            ) : (
                                <button
                                    type="button"
                                    className="button-warning me-3"
                                    onClick={handleShowDisapproveModal}
                                >
                                    Reject
                                </button>
                            )}
                            {isClicked ? (
                                <div className="button-primary me-3 d-flex justify-content-center">
                                    <ReactLoading
                                        type="bubbles"
                                        color="#FFFFFF"
                                        height={50}
                                        width={50}
                                    />
                                </div>
                            ) : (
                                <button
                                    type="button"
                                    className="button-primary me-3"
                                    onClick={handleShowApproveModal}
                                >
                                    Create Transfer
                                </button>
                            )}
                            <button
                                type="button"
                                className="button-secondary me-3"
                                onClick={() => navigate("/requests")}
                            >
                                Close
                            </button>
                        </div>
                    )}
                </div>
            </div>

            {/* PRINT VIEW */}
            <div
                className="print-container px-3 py-2 display-none"
                id="printablediv"
            >
                <div className="text-end print-header d-flex flex-column">
                    <span>TRANSFER NO. {id}</span>
                    <span className="text-uppercase">
                        {Moment(getTodayDateISO()).format("MMMM DD, yyyy")}
                    </span>
                </div>
                <div className="d-flex justify-content-center">
                    <img src={cleanLogo} className="print-logo" alt="" />
                </div>
                <div className="print-top">
                    <h5 className="print-shop-header d-flex justify-content-center">LEYTE PAPERWORLD</h5>
                    <h5 className="print-shop-header d-flex justify-content-center">168 M.H. Del Pilar, Tacloban City, Leyte</h5>
                    <h5 className="print-shop-header d-flex justify-content-center">(053) 325-3888 (053) 325-7088</h5>
                    <h5 className="print-shop-header d-flex justify-content-center">penpaperworld@yahoo.com</h5>
                    <h5 className="print-shop-header d-flex justify-content-center">REQUEST</h5>
                </div>
                <div className="print-body mt-2">
                    <Container fluid>
                        <Row className="review-container py-2">
                            <Col>
                                <div className="d-flex align-items-center">
                                    <Col xs={4} className="print-label">
                                        Doc No.:
                                    </Col>
                                    <Col xs={7} className="print-data">
                                        {request.id}
                                    </Col>
                                </div>
                                <div className="d-flex align-items-center">
                                    <Col xs={4} className="print-label">
                                        Request Date:
                                    </Col>
                                    <Col xs={7} className="print-data">
                                        {dateFormat(request.request_date)}
                                    </Col>
                                </div>
                                <div className="d-flex align-items-center">
                                    <Col xs={4} className="print-label">
                                        Delivery Date:
                                    </Col>
                                    <Col xs={7} className="print-data">
                                        {dateFormat(request.delivery_date)}
                                    </Col>
                                </div>
                                <div className="d-flex align-items-center">
                                    <Col xs={4} className="print-label">
                                        Encoded By:
                                    </Col>
                                    <Col xs={7} className="print-data">
                                        {request.encoded_by_name}
                                    </Col>
                                </div>
                                <div className="d-flex align-items-center">
                                    <Col xs={4} className="print-label">
                                        Approved By:
                                    </Col>
                                    <Col xs={7} className="print-data">
                                        {request.approved_by_name}
                                    </Col>
                                </div>
                            </Col>
                            <Col>
                                <div className="d-flex align-items-center">
                                    <Col xs={4} className="print-label">
                                        Request From:
                                    </Col>
                                    <Col xs={7} className="print-data">
                                        {request.branch_from_name}
                                    </Col>
                                </div>
                                <div className="d-flex align-items-center">
                                    <Col xs={4} className="print-label">
                                        Request To:
                                    </Col>
                                    <Col xs={7} className="print-data">
                                        {request.branch_to_name}
                                    </Col>
                                </div>
                                <div className="d-flex align-items-center">
                                    <Col xs={4} className="print-label">
                                        Remarks:
                                    </Col>
                                    <Col xs={7} className="print-data">
                                        {request.remarks}
                                    </Col>
                                </div>
                                <div className="d-flex align-items-center">
                                    <Col xs={4} className="print-label">
                                        Approval Remarks:
                                    </Col>
                                    <Col xs={7} className="print-data">
                                        {request.approval_remarks}
                                    </Col>
                                </div>
                            </Col>
                        </Row>
                    </Container>

                    {/* <div className="mt-1 d-flex flex-column">
                        <span className="review-data mb-1 nc-modal-custom-row">
                            LIST OF THE ITEMS REQUESTED
                        </span>
                        <div className="d-flex mt-2 justify-content-evenly">
                            <div className="print-table mt-3 mx-2">
                                {renderTablePrint()}
                            </div>
                        </div>
                    </div> */}
                    <div className="mt-4 d-flex flex-column">
                        <span className="review-data mb-2 nc-modal-custom-row">
                            LIST OF ITEMS REQUESTED
                        </span>
                        <div className="d-flex mt-2 justify-content-evenly">
                            <div className="print-table mt-3 mx-2">
                                {renderTablePrint()}
                            </div>
                        </div>
                    </div>
                    <Row className="mt-5">
                        <Col xs={6} className="print-sig justify-content-center d-flex">
                            <img src={request.added_by_name_signature} className="print-logo" />
                        </Col>
                        <Col xs={6} className="print-sig justify-content-center d-flex">
                            <img src={request.approved_by_name_signature} className="print-logo" alt=""/>
                        </Col>
                    </Row>
                    <Row className="mt-2 mb-5">
                        <Col xs={6} className="print-sig justify-content-center d-flex">
                            <Row className="print-sig justify-content-center gotham">
                                {request.added_by_name}
                            <div className="margin-underline"></div>
                            Prepared by
                            </Row>
                        </Col>
                        <Col xs={6} className="print-sig justify-content-center d-flex">
                            <Row className="print-sig justify-content-center gotham">
                            {request.approved_by_name}
                            <div className="margin-underline"></div>
                            Approved by
                            </Row>
                        </Col>
                    </Row>
                </div>
            </div>

            <ApproveRequestModal
                show={showApproveModal}
                hide={handleCloseApproveModal}
                type="create transfer"
                handler={redirectToTransfer}
            />
            <RequestModal
                show={showDisapproveModal}
                hide={handleCloseDisapproveModal}
                type="reject"
                selectedRow={request}
                page={"view"}
            />
            <ApproveRequestModal
                show={showPrintModal}
                hide={handleClosePrintModal}
                type="print"
                handler={handlePrintPI}
            />
            <ApproveRequestModal
                show={showForApprovalModal}
                hide={handleCloseForApprovalModal}
                type="approve"
                handler={approveRequest}
            />
            
            <Footer/>
        </div>
    );
}
